type Props = {
  items: string[];
};

export function MilestoneNotExpectedPills({ items }: Props) {
  if (items.length === 0) return null;
  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-wide text-muted-foreground font-medium">
        Ainda não esperado
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((it) => (
          <span
            key={it}
            className="inline-flex items-center rounded-full border bg-muted/40 px-3 py-1 text-xs text-muted-foreground"
          >
            {it}
          </span>
        ))}
      </div>
    </div>
  );
}
